import { render, staticRenderFns } from "./EcosystemNeedsModal.vue?vue&type=template&id=6466a477&scoped=true"
import script from "./EcosystemNeedsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EcosystemNeedsModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466a477",
  null
  
)

export default component.exports